import { Moment } from "moment";
import { Document } from "../Document/Document.type";
import { ApiCallState } from "../Utils";
import { User } from "../User/User.type";

export type Task = {
  assigned_to: any;
  id: number | null;
  task_no: string;
  task_name: string;
  company: string;
  type: string;
  priority: string;
  explanation?: string;
  date: Moment;
  project_name: string;
  created_by_department: string;
  created_by: number;
  document: Document;
  task_details: TaskDetail[];
  task_remarks: TaskRemark[];
  task_reports: TaskReport[];
  user_id: number;
  project_id: number;
  user:User;
  users: {
    id: number;
    user_task: {
      id: number;
      user_id: number;
      task_id: number;
      last_seen: string;
    };
  }[];

  readonly createdAt: Date;
};

export type TaskDetail = {
  id: number | null;
  task_id: number;
  check: boolean;
  assigned_to: number[];
  assigned_to_department: string[];
  description: string;
  due_date: string;
  remark: string;
  checked_date: string;
  type: string;
  task_detail_attachments: TaskDetailAttachment[];
};

export type TaskReport = {
  id: number | null;
  task_id: number;
  challenge: string;
  result: string;
  learning: string;
};
export type TaskDetailAttachment = {
  id: number;

  task_detail_id: number;
  url: string;
  size: number;
  createdAt: string;
};

export type TaskRemark = {
  id: number | null;
  task_id: number | null;
  date: string;
  remarked_by: number;
  url: string;
  size: number;
  remark: string;
  createdAt: string;
};

export interface TaskSummaryReport {
  active_tasks: Task[];
  completed_tasks: Task[];
  expired_tasks: Task[];
  total_tasks: number;
  completion_rate: number;
}

export type TaskStateTypes = {
  fetchAll: ApiCallState<Task[]>;
  fetchAllMod: ApiCallState<Task[]>;
  fetchOne: ApiCallState<Task | {}>;
  fetchSummaryReport: ApiCallState<TaskSummaryReport | {}>;
};

export const TaskActionTypes = {
  FETCH_ALL_TASK: "FETCH_ALL_TASK",
  FETCH_ALL_TASK_RESET: "FETCH_ALL_TASK_RESET",
  FETCH_ALL_TASK_FAILURE: "FETCH_ALL_TASK_FAILURE",
  FETCH_ALL_TASK_SUCCESS: "FETCH_ALL_TASK_SUCCESS",

  FETCH_ALL_MOD_TASK: "FETCH_ALL_MOD_TASK",
  FETCH_ALL_MOD_TASK_RESET: "FETCH_ALL_MOD_TASK_RESET",
  FETCH_ALL_MOD_TASK_FAILURE: "FETCH_ALL_MOD_TASK_FAILURE",
  FETCH_ALL_MOD_TASK_SUCCESS: "FETCH_ALL_MOD_TASK_SUCCESS",

  FETCH_ONE_TASK: "FETCH_ONE_TASK",
  FETCH_ONE_TASK_RESET: "FETCH_ONE_TASK_RESET",
  FETCH_ONE_TASK_FAILURE: "FETCH_ONE_TASK_FAILURE",
  FETCH_ONE_TASK_SUCCESS: "FETCH_ONE_TASK_SUCCESS",

  FETCH_TASK_SUMMARY_REPORT: "FETCH_TASK_SUMMARY_REPORT",
  FETCH_TASK_SUMMARY_REPORT_RESET: "FETCH_TASK_SUMMARY_REPORT_RESET",
  FETCH_TASK_SUMMARY_REPORT_FAILURE: "FETCH_TASK_SUMMARY_REPORT_FAILURE",
  FETCH_TASK_SUMMARY_REPORT_SUCCESS: "FETCH_TASK_SUMMARY_REPORT_SUCCESS",
};
